<template>
  <section class="bg-[#f9f9f9] py-10 px-4 text-center">
    <h1 class="text-4xl font-semibold mb-4 text-gray-900">Nossa história</h1>
    <p class="text-sm text-gray-500 mb-28">conheça um pouco das nossas conquistas e histórias</p>

    <div class="relative max-w-6xl mx-auto">
      <!-- Linha -->
      <div class="absolute top-6 left-0 right-0 h-px bg-gray-200"></div>

      <!-- Itens -->
      <div class="grid grid-cols-5 gap-6 relative z-10 mb-28">
        <div v-for="(item, i) in timeline" :key="i" class="flex flex-col items-center text-center">
          <span :class="`text-sm font-bold mb-2 ${item.color}`">{{ item.ano }}</span>

          <span
            :class="`w-8 h-8 rounded-full mb-4 border-4 border-white ${item.bg}`"
          ></span>

          <div class="h-4 border-l-2" :class="item.border"></div>

          <h3 class="font-bold text-lg mt-4">{{ item.titulo }}</h3>
          <p class="text-sm text-gray-500 leading-relaxed max-w-[200px] mt-2">{{ item.descricao }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const timeline = [
  {
    ano: '2000',
    titulo: 'Nasceu',
    descricao: 'Aqui foi o inicio de tudo, começamos a fornecer hospedagem simples em php e html',
    color: 'text-yellow-400',
    bg: 'bg-yellow-400',
    border: 'border-yellow-400 border-dotted'
  },
  {
    ano: '2004',
    titulo: 'Java',
    descricao: 'Devido à carência em hospedagem fomos um dos pioneiros a fornecer essa tecnologia',
    color: 'text-pink-500',
    bg: 'bg-pink-500',
    border: 'border-pink-500 border-dotted'
  },
  {
    ano: '2007',
    titulo: 'Painel Java',
    descricao: 'Desenvolvemos painéis exclusivos para as tecnologias Java.',
    color: 'text-indigo-900',
    bg: 'bg-indigo-900',
    border: 'border-indigo-900 border-dotted'
  },
  {
    ano: '2020',
    titulo: 'Painel Node.js e Spring',
    descricao: 'Novos painéis exclusivos para gerenciamento Node.js e Spring Boot',
    color: 'text-purple-700',
    bg: 'bg-purple-700',
    border: 'border-purple-700 border-dotted'
  },
  {
    ano: '2024',
    titulo: 'Integrator ICP',
    descricao: 'Nosso painel exclusivo para gestão de VPS',
    color: 'text-red-700',
    bg: 'bg-red-700',
    border: 'border-purple-700 border-dotted'
  }
]
</script>
